import React, { useEffect, useState } from 'react';
import {
  Master,
  PageWrapper,
  PanelWrapper,
  TitlePage,
  PanelTopWrapper,
  ClicksCard,
  DateRange,
} from 'components';
import {
  GetSpreadSheetService,
  GetDashBoard
} from 'services';
import { Button } from 'reactstrap';
import { Line } from 'react-chartjs-2';
import './dashboard.scss';

export const Dashboard = () => {
  const [clicks, setClicks] = useState([]);
  const [labels, setLabels] = useState([]);
  const [dataAccess, setDataAccess] = useState([]);
  const [dataClicks, setDataClicks] = useState([]);
  const [filterValue, setFilterValue] = useState("");

  useEffect(() => {
    GetDashBoard(filterValue?.start, filterValue?.end).then((dash) => {
      setClicks(dash?.clicks);
      setLabels(dash?.graphClicks.labels);
      setDataClicks(dash?.graphClicks.dataSets.data)
      setDataAccess(dash?.graphAccess.dataSets.data)
    })
  }, [filterValue]);

  const validateFilter = () => {
    return (filterValue?.start && filterValue?.end) ? filterValue : false;
  }

  const exportSpreadSheet = () => {
    GetSpreadSheetService({filter: validateFilter()});
  }

  const dashboard = {
    data: {
      labels: labels,
      datasets: [
        {
          label: 'Acessos',
          data: dataAccess,
          fill: false,
          backgroundColor: 'rgb(190,194,199)',
          borderColor: 'rgb(190,194,199)',
        },
        {
          label: 'Cliques',
          data: dataClicks,
          fill: false,
          backgroundColor: 'rgb(30, 190, 132)',
          borderColor: 'rgb(30, 190, 132)',
        },
      ],
    },
  };

  const filter = (period) => {
    setFilterValue(period);
  }

  return (
    <>
      <Master>
        <PageWrapper>
          <PanelTopWrapper padding={"py-4"}>
            <TitlePage title={'Dashboard'} />
            <DateRange getPeriod={filter} />
          </PanelTopWrapper>
          <div className="container-full">
            <div className="row">
              <ClicksCard data={clicks} />
            </div>
          </div>
          <PanelWrapper>
            <Line data={dashboard.data} height={100} />
          </PanelWrapper>
        </PageWrapper>
        <PanelTopWrapper id="export" padding={"px-4 py-1"}>
          <Button onClick={exportSpreadSheet} color="primary">
            Exportar Dados
          </Button>
        </PanelTopWrapper>
      </Master>
    </>
  );
};
